import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import Navbar from "../../nav_bar/Navbar";
import Footer from "../../footer/Footer";
import { fetchGroupById, fetchWordsByGroup } from "./similarWordsService";
import { BASE_ROOT } from "../../../../common/api_constant";
import "./SimilarWords.css";

const getYouTubeId = (url) => {
	if (!url) return null;
	const match = url.match(/(?:v=|\/embed\/|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
	return match ? match[1] : null;
};

const SimilarWordsDetailPage = () => {
	const { groupId } = useParams();
	const navigate = useNavigate();
	const [group, setGroup] = useState(null);
	const [words, setWords] = useState([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const load = async () => {
			setLoading(true);
			const gRes = await fetchGroupById(groupId);
			if (gRes.status === 200 && gRes.data) {
				const g = gRes.data.data || gRes.data;
				setGroup(g);
			}
			const wRes = await fetchWordsByGroup(groupId);
			if (wRes.status === 200 && wRes.data) {
				const list = wRes.data.data || (Array.isArray(wRes.data) ? wRes.data : []);
				setWords(list);
			}
			setLoading(false);
		};
		load();
	}, [groupId]);

	if (loading) return (<><Navbar /><div className="sw-detail"><p className="sw-loading">Loading...</p></div><Footer /></>);
	if (!group && words.length === 0) return (<><Navbar /><div className="sw-detail"><p className="sw-loading">Group not found.</p><button className="sw-back" onClick={() => navigate("/study/similar-words")}>← Back</button></div><Footer /></>);

	const videoId = getYouTubeId(group?.youtubeVideoLink);

	return (
		<>
			<Navbar />
			<div className="sw-detail">
				<button className="sw-back" onClick={() => navigate("/study/similar-words")}>← Back to Similar Words</button>
				<div className="sw-hero">
					<h1 className="sw-hero-title">{group?.title || words[0]?.wordGroupTitle}</h1>
				</div>

				{group?.imageUrl && (
					<div style={{ borderRadius: 16, overflow: "hidden", marginBottom: 20 }}>
						<img
							src={`${BASE_ROOT}${group.imageUrl}`}
							alt={group.title}
							style={{ width: "100%", maxHeight: 280, objectFit: "contain", background: "#f5f5f5", display: "block" }}
						/>
					</div>
				)}

				{videoId && (
					<div className="sw-video-card">
						<p className="sw-video-title">📺 Watch Video</p>
						<div className="sw-video-wrapper">
							<iframe src={`https://www.youtube.com/embed/${videoId}`} title="YouTube video" allowFullScreen />
						</div>
					</div>
				)}

				<div className="sw-word-list">
					{words.map((w) => (
						<div key={w.id} className="sw-word-card">
							{w.imageUrl && (
								<img src={`${BASE_ROOT}${w.imageUrl}`} alt={w.word} className="sw-word-image"
									style={{ width: "100%", maxHeight: 160, objectFit: "contain", background: "#f5f5f5", borderRadius: 10, marginBottom: 10, display: "block" }} />
							)}
							<div className="sw-word-header">
								<h3 className="sw-word-name">{w.word}</h3>
							</div>
							{(w.pronunciation || w.phoneticSpelling) && (
								<div className="sw-pron-row">
									{w.pronunciation && (
										<span className="sw-word-pron">
											<span className="sw-pron-label">IPA <Link to="/study/ipa/lessons" className="sw-ipa-info" title="Learn IPA symbols" onClick={(e) => e.stopPropagation()}>ℹ</Link></span>
											{w.pronunciation}
										</span>
									)}
									{w.phoneticSpelling && (
										<span className="sw-word-phonetic">
											<span className="sw-pron-label">How to say</span>
											{w.phoneticSpelling}
										</span>
									)}
								</div>
							)}
							<p className="sw-word-meaning">{w.meaning}</p>
							{w.examples && <div className="sw-word-example">{w.examples}</div>}
						</div>
					))}
				</div>
			</div>
			<Footer />
		</>
	);
};

export default SimilarWordsDetailPage;
